<style lang="scss"></style>
<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 0px;box-sizing: border-box;">
      <img style="width: auto;height: 42px;" src="../../../../../../assets/img/web/weier/production/30tzhfx.png" />
    </div>
    <div class="weier-prodcution-monitor-border" style="padding: 10px;">

      <div style="display: flex;align-items: center;justify-content: space-between;" :style="{ height: contentHeight + 'px' }">
        <div style="width: 33%;">
          <div id="weierhegelvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;display: flex;justify-content: center;"></div>
        </div>
        <div style="width: 33%;">
          <div id="weierkaijilvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;display: flex;justify-content: center;"></div>
        </div>
        <div style="width: 33%;">
          <div id="weierjiadonglvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;display: flex;justify-content: center;"></div>
        </div>
      </div>
    </div>

  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_oee",
  components: {},
  props: {
    datas: {
      type: Object,
      default: () => {
        return {
        };
      },

    },
  },
  data() {
    return {
      contentHeight: 0,

      hglChart: null,
      kjlChart: null,
      jdlChart: null,
    };
  },
  watch: {
    "datas": {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue, this.datas)
        if (this.utils.isEqual(newValue, oldValue)) {
          return;
        }
        setTimeout(() => {
          this.makeData();

        }, 1000);
      },
      immediate: true,
      deep: true
    },
  },
  created() {

  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      if (!this.hglChart) {
        this.initHglChart();
      }
      if (!this.kjlChart) {
        this.initKjlChart();
      }
      if (!this.jdlChart) {
        this.initJdlChart();
      }
      this.resize();
    }, 700);

    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    async makeData() {
      if (this.datas.firstCheckRate !== null) {
        this.hglChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.datas.firstCheckRate,
                  name: this.$t("首检合格率"),
                },
              ],
            },
          ],
        });
      }
      if (this.datas.openRate !== null) {
        this.kjlChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.datas.openRate,
                  name: this.$t("kaijilv"),
                },
              ],
            },
          ],
        });
      }

      if (this.datas.activeRate !== null) {
        this.jdlChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.datas.activeRate,
                  name: this.$t("jiadonglv"),
                },
              ],
            },
          ],
        });
      }

      this.resize();
    },
    resize() {
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 2 - 20;

        setTimeout(() => {
          if (this.hglChart) {
            this.hglChart.resize();
          }
          if (this.kjlChart) {
            this.kjlChart.resize();
          }
          if (this.jdlChart) {
            this.jdlChart.resize();
          }
        }, 0);
      }, 800); //子组件填800，因为父组件500，等父组件调整好高度先
    },
    initHglChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "55%"],
            startAngle: 90,
            endAngle: -270,
            min: 0,
            max: 100,
            radius: "70%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253, 157, 255, 1)", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(79, 50, 255, 1)", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              roundCap: false,
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,

            },
            axisLabel: {

              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-130%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "0%"],
              fontSize: 16,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("首检合格率"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("weierhegelvChart");
      this.hglChart = this.echarts.init(chartDom);
      option && this.hglChart.setOption(option);
    },
    initKjlChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "55%"],
            startAngle: 90,
            endAngle: -270,
            min: 0,
            max: 100,
            radius: "70%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253, 157, 255, 1)", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(79, 50, 255, 1)", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              roundCap: false,
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,

            },
            axisLabel: {

              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-130%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "0%"],
              fontSize: 16,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("kaijilv"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("weierkaijilvChart");
      this.kjlChart = this.echarts.init(chartDom);
      option && this.kjlChart.setOption(option);
    },
    initJdlChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "55%"],
            startAngle: 90,
            endAngle: -270,
            min: 0,
            max: 100,
            radius: "70%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253, 157, 255, 1)", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(79, 50, 255, 1)", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              roundCap: false,
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,

            },
            axisLabel: {

              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-130%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "0%"],
              fontSize: 16,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("jiadonglv"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("weierjiadonglvChart");
      this.jdlChart = this.echarts.init(chartDom);
      option && this.jdlChart.setOption(option);
    },
  },
};
</script>
